import {Inject, Injectable} from '@angular/core';
import {AuthorizationError} from 'app/core/error-handler/errors/authorization.error';
import {FreezingErrorsDetector} from 'app/core/error-handler/freezing-errors-detector';
import {environment} from '../../../environments/environment';
import {LocalAlertsService} from '../services/alerts/local-alerts.service';
import {InternalError} from './errors/internal-error';
import {NoConnectionError} from './errors/network/no-connection-error';
import {Sentry} from './sentry.service';
import {REDIRECT_TO_LEGACY_LOGIN} from 'app/core/helpers/redirect';

@Injectable()
export class ErrorNotifierService {
    constructor(
        private alerts: LocalAlertsService,
        private sentry: Sentry,
        private freezingDetector: FreezingErrorsDetector,
        @Inject(REDIRECT_TO_LEGACY_LOGIN) private redirectToLogin: () => void
    ) {
        this.freezingDetector.onErrorDetected = e => {
            this.sentry.handleError(e);
        };
    }

    notifyBugTracker(error: InternalError) {
        if (!error.reported) {
            this.sentry.handleError(error);
            error.reported = true;
        }
    }

    notifyUser(error: InternalError, forced = false) {
        this.freezingDetector.handleError(error);
        if (!error.isHandled || forced) {
            this.alerts.addAlert(error.userMessage);
            error.isHandled = true;
        }
    }

    handleError(error: InternalError, silent = false) {
        if (!error) {
            return;
        }
        /* istanbul ignore next */
        if (!environment.production) {
            console.error(error);
            console.error(error.originalError);
        }
        if (error instanceof AuthorizationError) {
            return this.redirectToSignIn();
        }
        if (error.uncaught || error.isCritical()) {
            this.notifyBugTracker(error);
        }
        if (error.uncaught || error.isCritical() || error instanceof NoConnectionError) {
            if (!silent) {
                this.notifyUser(error);
            }
        } else {
            this.freezingDetector.handleError(error);
        }
    }

    redirectToSignIn() {
        return this.redirectToLogin();
    }
}
